module.exports = __webpack_public_path__ + "img/left-leg.d23432ec.png";